import { SvgIconProps } from '@mui/material';
import { VerifiedUser } from '@mui/icons-material';

export default function CommercialIcon(props: SvgIconProps) {
    return <VerifiedUser {...props} />;
}
